"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableFilterTypes = void 0;
var _react = _interopRequireDefault(require("react"));
var _FuzzyTextFilterFn = require("./FuzzyTextFilterFn");
var _SimpleTextFilterFn = require("./SimpleTextFilterFn");
var _GreaterThanFilterFn = require("./GreaterThanFilterFn");
var _LessThanFilterFn = require("./LessThanFilterFn");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TableFilterTypes = () => {
  return {
    fuzzyText: _FuzzyTextFilterFn.FuzzyTextFilterFn,
    greaterThan: _GreaterThanFilterFn.GreaterThanFilterFn,
    lessThan: _LessThanFilterFn.LessThanFilterFn,
    text: _SimpleTextFilterFn.SimpleTextFilterFn
  };
};
exports.TableFilterTypes = TableFilterTypes;